module.exports = __webpack_public_path__ + "static/media/hair-testing-img.f5afd9c0.png";